import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  // Check if user is logged in by checking localStorage (or use context, redux, etc.)
  const token = localStorage.getItem("token"); // or whatever key you store JWT/token as

  // If no token, redirect to login page
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Else render the child routes
  return <Outlet />;
};

export default ProtectedRoute;
